// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import App from './App'
import router from './router'
import './assets/less/common.css'
import './assets/styles/iconfont.css'
import store from './store/'
import * as loginAuthentication from './util/loginAuthentication';
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(ElementUI)
Vue.prototype.$loginAuthentication = loginAuthentication;
/* eslint-disable no-new */
// 路由跳转后，页面回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
})
if (process.env.VUE_APP_ENV === 'online') {
  // eslint-disable-next-line
  var _hmt = _hmt || [];
  window._hmt = _hmt;// 修改为window 全局变量
  (function () {
    var hm = document.createElement('script');
    var s = document.getElementsByTagName('script')[0];
    hm.src = 'https://hm.baidu.com/hm.js?11d192605d2c4ebab23bdd877f5d5ece';
    s.parentNode.insertBefore(hm, s);
  })();
}
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js